import "./App.css";
import "overlayscrollbars/styles/overlayscrollbars.css";

import { observer, Provider } from "mobx-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import { AppStore } from "./stores/AppStore";
import { Home } from "./views/login/home/Home";
import Login from "./views/login/Login";
import { AzureAuthResult } from "./views/login/auth/AzureAuthResult";
import { NotFound } from "./components/not_found/NotFound";
import { AppBar } from "./components/app_bar/AppBar";
import { StatusBarWrapper } from "./components/status_bar/StatusBar";
import { ClientHome } from "./views/client/ClientHome";
import { ClientWizard } from "./views/client/ClientWizard";
import { Depots } from "./views/cruds/depots/Depots";
import { Users } from "./views/cruds/users/Users";
import { Permissions } from "./views/cruds/permissions/Permissions";
import Clients from "./views/cruds/clients/Clients";
import { Partners } from "./views/cruds/partners/Partners";
import { Cronjobs } from "./views/cruds/cronjobs/Cronjobs";
import Preloader from "./components/preloader/Preloader";

const appStore = AppStore.getInstance();

function renderRoutes() {
  const { authenticated } = appStore;

  if (authenticated) {
    return (
      <div className="App bg-gray-100 flex-1 overflow-y-auto">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/client-home" element={<ClientHome store={appStore} />} /> */}
          {/* <Route path="/cruds/depots" element={<Depots store={appStore} />} /> */}
          <Route path="/configuration/users" element={<Users store={appStore} />} />
          <Route path="/configuration/clients" element={<Clients store={appStore} />} />
          <Route path="/configuration/partners" element={<Partners store={appStore} />} />
          <Route path="/configuration/clients/:clientId/cronjobs" element={<Cronjobs store={appStore} />} />
          <Route path="/configuration/permissions" element={<Permissions store={appStore} />} />
          {/* <Route path="/configuration/create-client" element={<ClientWizard store={appStore} />} /> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  } else {
    return (
      <div className="App flex-1">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/azure_callback_success" element={<AzureAuthResult />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    );
  }
}

function App() {
  const { authenticated, preLoaderProps } = appStore;

  return (
    <ConfigProvider theme={{ token: { fontSize: 12 } }}>
      <Provider store={appStore}>
        <BrowserRouter>
          <div className="flex flex-col h-screen">
            <Preloader progressText={preLoaderProps.loadingText} loading={preLoaderProps.loading} />
            {authenticated && <AppBar fixed />}
            {renderRoutes()}
            {authenticated && appStore.statusBar.visible && <StatusBarWrapper />}
          </div>
        </BrowserRouter>
      </Provider>
    </ConfigProvider>
  );
}

export default observer(App);
// export default App;
